export function getDynamicTranslationKey(path: string, key: string): string {
  return path + '.' + key.replace(' ' || '(', '-').toLowerCase();
}
